import { registerLocaleData, formatDate } from '@angular/common';
import localeUk from '@angular/common/locales/uk';
registerLocaleData(localeUk, 'uk');

import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { Subscription, Subject, from, of, filter, finalize, } from 'rxjs';
import { map, tap, concatMap, catchError } from 'rxjs/operators';
import { HttpErrorResponse } from '@angular/common/http';

import { environment } from 'src/environments/environment';

import { GlobalSettingsData } from 'src/app/shared/global-settings-data'
import { GetglobalsettingsService } from 'src/app/services/getglobalsettings.service'
import { Currency, CurrencyRate, CurrencyRateListItem } from 'src/app/shared/currency';
import { RestApiService, crListFetchParams } from 'src/app/services/rest-api.service';
import { ExternalApiService, nbuRateItem } from 'src/app/services/external-api.service';
import { planMinfinPoint } from './minfin-rate-plan';
import { saveAs } from 'file-saver';

@Component({
  selector: 'app-update-currency-by-external-api',
  templateUrl: './update-currency-by-external-api.component.html',
  styleUrls: ['./update-currency-by-external-api.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class UpdateCurrencyByExternalApiComponent implements OnInit, OnDestroy {

  private globalSettinsData: GlobalSettingsData = null;

  currencyRatesList: CurrencyRateListItem[] = [];
  selectedCurrencyRatesItem: CurrencyRateListItem = null;

  private currRateQuery: Subscription = null;
  private currencyQuery: Subscription = null;
  private ratesQuery: Subscription = null;
  private editRatesQuery: Subscription = null;

  currencyList: Currency[] = [];

  logRows: string[] = [];

  loading: boolean = false;

  totalRecords: number = 0;

  private currencyList$ = new Subject();

  ercToken: any = {};
  ercRates: any = {};

  constructor(
    private restapi: RestApiService,
    private extapi: ExternalApiService,
    private globalsettingsservice: GetglobalsettingsService,
  ) { }

  ngOnDestroy(): void {
    console.log('*** UpdateCurrencyByExternalApiComponent ngOnDestroy: ');

    if (this.currRateQuery) { this.currRateQuery.unsubscribe(); }

    if (this.currencyQuery) { this.currencyQuery.unsubscribe(); }

    if (this.ratesQuery) { this.ratesQuery.unsubscribe(); }

    if (this.editRatesQuery) { this.editRatesQuery.unsubscribe(); }
  }

  ngOnInit(): void {
    console.log('*** UpdateCurrencyByExternalApiComponent ngOnInit: ');

    this.globalSettinsData = this.globalsettingsservice.getGlobalSettings();

    this.loading = true;

    this.currRateQuery =
      this.currencyList$
      .pipe(
        concatMap(() => this.restapi.getCurrencyLatestRates().pipe(
          map(data => {
            this.currencyRatesList = data || [];

            this.totalRecords = this.currencyRatesList.length;

            environment.production || console.table(this.currencyRatesList);
          }),

          finalize(() => {
            this.loading = false;
          })
        )),

      )
      .subscribe();

    this.currencyList$.next(false);
}

  /**
   * @description Get today rates from API1 (NBU)
   * 
   * @param event - nothing useful (button event)
   */
  onGetExtApiRate1(event) {
    console.log('*** CurrencyRatesComponent onGetExtApiRate1: ' + JSON.stringify(event));

    this.loading = true;

    this.ratesQuery = this.restapi.getCurrencyLatestRates()
      .pipe(
        concatMap(data => {
          this.currencyRatesList = data || [];

          this.totalRecords = this.currencyRatesList.length;

          return from(this.currencyRatesList);
        }),

        filter(curr => (curr.APINAME == 'NBU')),

        //tap(curr => console.table(curr)),
        concatMap(curr => this.extapi.getNBUCurrencyRate(curr.CURCODE).pipe(

          filter(resp => resp.length > 0),
          //tap(curr => console.table(curr)),
          concatMap(resp => from(resp)),        // convert [{}] to {}

          concatMap(nbu => of(nbu).pipe(

            concatMap(nbu => {

              this.logRows = [...this.logRows, (JSON.stringify(nbu) + '\n')];

              let options: crListFetchParams = {
                st: 0,
                ft: 10,
                fs: {
                  "CURCODE": { "value": [{ "CURID": curr.CURID }], "matchMode": "in" }
                },
                sp: {          // Sorting parameters object
                  sf: 'CRDATE',
                  so: -1
                }
              };

              console.log(JSON.stringify(options));

              return this.restapi.getCurrencyRates(options);
            }),

            // Check is there same date rate value

            filter(rates => {
              const ed: string[] = nbu.exchangedate.split('.');
              const nd: Date = new Date(Date.UTC(parseInt(ed[2]), parseInt(ed[1]) - 1, parseInt(ed[0])));

              return (rates.findIndex(e => ((new Date(e.CRDATE)).getTime() == nd.getTime())) == -1);
            }),
            tap(() => console.log('*** No value on this date')),

            // Check if currency has a difference value (need to update)

            filter(rates => {
              const cv = parseFloat(nbu.rate);

              return (rates.length == 0) || (rates[0].CRVALUE != cv);
            }),
            tap(() => console.log('*** Recent value is not equal')),

            concatMap(() => {

              const ed: string[] = nbu.exchangedate.split('.');

              let nr: CurrencyRateListItem = {

                ...curr, CRDATE: new Date(parseInt(ed[2]), parseInt(ed[1])-1, parseInt(ed[0],0)), CRVALUE: parseFloat(nbu.rate)
              };

              console.log(JSON.stringify(nr));
              return this.restapi.postCurrencyRates(nr);
            }),

            tap(row => { this.logRows = [...this.logRows, (JSON.stringify(row) + '\n')]; })

          )),
        )),

        finalize(() => {
          this.loading = false;
          this.logRows = [... this.logRows];
          this.currencyList$.next(false);
        })
      )
      .subscribe();

  //  this.currRateQuery = this.extapi.getNBUCurrencyRate('USD')
  //    .pipe(
  //      tap(data => console.log(JSON.stringify(data))),
  //      map(data => this.logRows.push(JSON.stringify(data))),
  //      finalize(() => { this.logRows = [... this.logRows];})
  //    )
  //    .subscribe();
  }

  /**
   * @description Get archived rates from API1 (NBU)
   * 
   * @param event - nothing useful (button event)
   */
  onGetExtApiRate2(event) {
    console.log('*** CurrencyRatesComponent onGetExtApiRate2: ' + JSON.stringify(event));

    this.loading = true;

    this.ratesQuery = this.restapi.getCurrencyLatestRates()
      .pipe(
        concatMap(data => {
          this.currencyRatesList = data || [];

          this.totalRecords = this.currencyRatesList.length;

          return from(this.currencyRatesList);
        }),

        filter(curr => (curr.APINAME == 'NBU')),

        // Here we assume few non obviuos things
        //
        // 1) curr points to latest rate set and there is no more newest records
        // 2) all duplicates removes from external api result array
        // 3) if first external api result equal to latest rate in database we simply remove first element from array
        //

        concatMap(curr => this.extapi.getNBUCurrencyRateHistory(curr.CURCODE, new Date( curr.CRDATE)).pipe(

          filter(resp => resp.length > 0),
          tap(curr => environment.production || console.table(curr)),

          // Leave only unique value
          concatMap(resp => {
            let f: nbuRateItem[] = [];

            resp.forEach(e => { if (!f.find(n => (parseFloat(n.rate) == parseFloat(e.rate)))) f.push(e) });

            environment.production || console.table(f);
            if (parseFloat(f[0].rate) == curr.CRVALUE) f.shift();

            environment.production || console.table(f);

            return from(f);
          }),
          tap(resp => environment.production || console.table(resp)),

          concatMap(nbu => {

              const ed: string[] = nbu.exchangedate.split('.');

              let nr: CurrencyRateListItem = {

                ...curr, CRDATE: new Date(parseInt(ed[2]), parseInt(ed[1]) - 1, parseInt(ed[0],0)), CRVALUE: parseFloat(nbu.rate)
              };

              console.log(JSON.stringify(nr));
              this.logRows = [...this.logRows, (JSON.stringify(nr) + '\n')];
              return this.restapi.postCurrencyRates(nr);
            }),

            tap(row => { this.logRows = [...this.logRows, (JSON.stringify(row) + '\n')]; })
        )),

        finalize(() => {
          this.loading = false;
          this.logRows = [... this.logRows];
          this.currencyList$.next(false);
        })
      )
      .subscribe();
  }

  /**
   * @description Get today rates from API2 (MB)
   * 
   * @param event - nothing useful (button event)
   */
  onGetExtApiRate3(event) {
    console.log('*** CurrencyRatesComponent onGetExtApiRate3: ' + JSON.stringify(event));

    this.loading = true;
    const log = (line: string) => { this.logRows = [...this.logRows, line + '\n']; };

    // The rate of today is the previous business day's last price (plan 15.10), never today's own intraday or closing price.
    this.ratesQuery = this.extapi.getMinfinMbRate(undefined, 'previous-close')
      .pipe(
        concatMap(resp => {
          // An API build without `basis=previous-close` ignores the parameter and answers with today's feed, whose latest slot
          // is today's own price: refuse to write anything from such an answer.
          if (resp.basis !== 'previous-close') {
            log('Minfin: the server did not answer on the previous-close basis (API is older than this screen), nothing written');
            return of(null);
          }
          if (resp.businessDay === false) {
            log(`Minfin: ${resp.rateDate} is not a business day, no rate to set`);
            return of(null);
          }
          log(`Minfin (${resp.priceField}), rate date ${resp.rateDate}, from the close of ${resp.requestedDate}: ${Object.keys(resp.points).length} point(s)`);
          resp.missing.forEach(c => log(`${c}: no usable point in the answer, skipped`));
          resp.skipped.forEach(c => log(`${c.curcode}: slot ${c.slot} skipped (${c.reason})`));

          return this.restapi.getCurrencyLatestRates().pipe(
            concatMap(data => {
              this.currencyRatesList = data || [];
              this.totalRecords = this.currencyRatesList.length;

              return from(Object.keys(resp.points));
            }),

            concatMap(curcode => {
              const curr = this.currencyRatesList.find(c => c.CURCODE === curcode);
              if (!curr) {
                const p = planMinfinPoint(curcode, resp.points[curcode], resp.rateDate, undefined, []);
                log(p.message);
                return of(null);
              }

              const options: crListFetchParams = {
                st: 0,
                ft: 10,
                fs: { "CURCODE": { "value": [{ "CURID": curr.CURID }], "matchMode": "in" } },
                sp: { sf: 'CRDATE', so: -1 }
              };

              return this.restapi.getCurrencyRates(options).pipe(
                concatMap(rates => {
                  const plan = planMinfinPoint(curcode, resp.points[curcode], resp.rateDate, curr, rates || []);
                  if (plan.warning) { log(plan.warning); }
                  log(plan.message);

                  if (plan.action !== 'write') { return of(null); }

                  return this.restapi.postCurrencyRates(plan.row).pipe(
                    tap(row => log('saved: ' + JSON.stringify(row)))
                  );
                }),

                // One currency failing must not stop the others: log its code and carry on.
                catchError((err: HttpErrorResponse) => {
                  log(`${curcode}: failed, ` + ((err && err.error && err.error.error) || (err && err.message) || 'request failed'));
                  return of(null);
                })
              );
            })
          );
        }),

        catchError((err: HttpErrorResponse) => {
          log('Minfin: ' + ((err && err.error && err.error.error) || (err && err.message) || 'request failed'));
          return of(null);
        }),

        finalize(() => {
          this.loading = false;
          this.currencyList$.next(false);
        })
      )
      .subscribe();
  }

  /**
   * @description Sync the single USD_ERC `CrossRates` row to ERC's current rate (API3).
   *
   * @param event - nothing useful (button event)
   *
   * @returns {"paperwork":38.45,"cash":39.2,"setoff":0}
   *
   * Design decision (owner, 2026-09-15), replacing the previous day-by-day
   * backfill logic entirely: ERC's price-export API (`InfoType=7`, checked
   * against ERC's own documentation and live capture, both the JSON format
   * this app requests and the XML alternative) never returns a genuine
   * per-update timestamp for a rate -- the XML `datetime` attribute the docs
   * show turned out, on live testing, to be a fixed noon placeholder (off by
   * ten minutes from a real intraday update, and returned even before noon
   * on a day nothing had posted yet), not a real clock reading tied to when
   * the value changed. ERC's own portal shows the rate changing more than
   * once on some days, but there is no way for this integration to recover
   * *when* within a day that happened, or to safely reconstruct a dated
   * history from it.
   *
   * Rather than keep manufacturing synthetic per-day `CRDATE` values that
   * don't correspond to anything ERC actually reported, `USD_ERC` now keeps
   * exactly ONE `CrossRates` row, updated in place to whatever ERC currently
   * reports. `CRDATE` on that row means "last synced at" (this app's own
   * query time) -- not a real ERC timestamp, since ERC doesn't have one to
   * give. Trade-off, accepted deliberately: any report reading `CrossRates`
   * history for `USD_ERC` no longer has one, only the current value -- but
   * existing documents are unaffected (`DOCRATEVAL` is copied onto a
   * document at creation time, never looked up live from `CrossRates`
   * afterward), and the row always matches the supplier's live price
   * instead of drifting until the next calendar-day import.
   */
  onGetExtApiRate4(event) {
    console.log('*** CurrencyRatesComponent onGetExtApiRate4: ' + JSON.stringify(event));

    this.loading = true;

    this.ratesQuery = this.restapi.getCurrencyLatestRates()
      .pipe(
        filter(data => (data.length > 0)),

        concatMap(data => {
          this.currencyRatesList = data;

          this.totalRecords = this.currencyRatesList.length;

          return from(this.currencyRatesList);
        }),

        filter(curr => (curr.CURCODE == 'USD_ERC')),

        concatMap(curr => this.extapi.getErcCurrencyrates(new Date()).pipe(
          map(resp => ({ curr, freshRate: resp.paperwork as number }))
        )),

        // Nothing changed since the last sync -- leave the single row as is.
        filter(({ curr, freshRate }) => (freshRate != curr.CRVALUE)),
        tap(() => console.log('*** ERC rate changed -- updating the single USD_ERC CrossRates row')),

        concatMap(({ curr, freshRate }) => {
          let nr: CurrencyRateListItem = { ...curr, CRDATE: new Date(), CRVALUE: freshRate };
          this.logRows = [...this.logRows, (JSON.stringify(nr) + '\n')];

          return this.restapi.putCurrencyRates(nr);
        }),

        finalize(() => {
          this.loading = false;
          this.logRows = [... this.logRows];
          this.currencyList$.next(false);
        })
      )
      .subscribe({
        error: (e) => console.error(e)
      });
  }
}
